import api from '../api/client';

export interface Category {
  id: string;
  parent_id: string | null;
  name: string;
  description: string | null;
  category_type: 'service' | 'material' | 'bundle';
  sort_order: number;
  is_active: boolean;
  children?: Category[];
}

export interface Product {
  id: string;
  category_id: string | null;
  code: string;
  name: string;
  description: string | null;
  product_type: 'service' | 'material' | 'bundle';
  pricing_type: 'hourly' | 'monthly' | 'per_vehicle' | 'per_user' | 'one_time' | 'custom';
  price: number;
  currency: string;
  min_quantity: number;
  quantity_step: number;
  unit: string;
  is_configurable: boolean;
  is_active: boolean;
  category_name?: string;
}

export const pricelistService = {
  // Kategorier
  async getCategories(): Promise<Category[]> {
    const response = await api.get('/api/pricelist/categories');
    return response.data.data;
  },

  async createCategory(data: Partial<Category>): Promise<Category> {
    const response = await api.post('/api/pricelist/categories', data);
    return response.data.data;
  },

  async updateCategory(id: string, data: Partial<Category>): Promise<Category> {
    const response = await api.put(`/api/pricelist/categories/${id}`, data);
    return response.data.data;
  },

  async deleteCategory(id: string): Promise<void> {
    await api.delete(`/api/pricelist/categories/${id}`);
  },

  // Produkter
  async getProducts(categoryId?: string): Promise<Product[]> {
    const params = categoryId ? `?categoryId=${categoryId}` : '';
    const response = await api.get(`/api/pricelist/products${params}`);
    return response.data.data;
  },

  async getProduct(id: string): Promise<Product> {
    const response = await api.get(`/api/pricelist/products/${id}`);
    return response.data.data;
  },

  async createProduct(data: Partial<Product>): Promise<Product> {
    const response = await api.post('/api/pricelist/products', data);
    return response.data.data;
  },

  async updateProduct(id: string, data: Partial<Product>): Promise<Product> {
    const response = await api.put(`/api/pricelist/products/${id}`, data);
    return response.data.data;
  },

  async deleteProduct(id: string): Promise<void> {
    await api.delete(`/api/pricelist/products/${id}`);
  },

  // Kundprodukter
  async getCustomerProducts(customerId: string): Promise<any[]> {
    const response = await api.get(`/api/pricelist/customers/${customerId}/products`);
    return response.data.data;
  },

  async addProductToCustomer(customerId: string, productId: string, data: any): Promise<any> {
    const response = await api.post(`/api/pricelist/customers/${customerId}/products`, {
      product_id: productId,
      ...data
    });
    return response.data.data;
  },

  async removeProductFromCustomer(customerProductId: string): Promise<void> {
    await api.delete(`/api/pricelist/customer-products/${customerProductId}`);
  }
};

